import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { authService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authService: authService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const userRole = this.authService.getUserRole();
    const allowedRoles = route.data['roles'] as string[];

    if (!allowedRoles || allowedRoles.length === 0) {
      return true; // No role restrictions for this route
    }

    // Check if user's role is in the allowed roles list
    if (allowedRoles.includes(userRole)) {
      return true;
    }

    // Redirect based on user role
    if (userRole === 'LEAD') {
      this.router.navigate(['/portal/notification']);
    } else {
      this.router.navigate(['/leads/leads-managment']);
    }
    
    return false;
  }
}